import { render, staticRenderFns } from "./LargeText.vue?vue&type=template&id=90583072&scoped=true"
import script from "./LargeText.vue?vue&type=script&lang=js"
export * from "./LargeText.vue?vue&type=script&lang=js"
import style0 from "./LargeText.vue?vue&type=style&index=0&id=90583072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90583072",
  null
  
)

export default component.exports